import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-star",
  "use": "foquz-icon-star-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" fill=\"none\" id=\"foquz-icon-star\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.977 15.843a.631.631 0 00.534-.71c0-.008-.786-4.96-.786-4.96l3.427-3.516a.653.653 0 00.004-.9.606.606 0 00-.342-.18l-4.77-.755L8.882.35a.604.604 0 00-1.097 0L5.623 4.822l-4.77.755a.633.633 0 00-.512.726.64.64 0 00.174.354l3.427 3.516-.783 4.933a.634.634 0 00.504.733c.132.023.269 0 .388-.065l4.282-2.298 4.283 2.298c.111.06.237.085.361.069z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol